import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { showToastAlert } from '../app';
import { goToPage, ROUTE_CLUES } from '../routing';
import {
  ACTION_CREATE_CLUE_TEN_STEP,
  ACTION_CREATE_CLUE_TEN_STEP_SKIP,
  createClueTenStepAPI,
  createClueTenStepSkipAPI,
  fetchListCountry,
  initClueTenStep,
  REQUEST_CREATE_CLUE_TEN_STEP_FAILURE,
  REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP,
  REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS,
  REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP,
} from './index';
import { fetchUserInfo } from '../auth';

function* handleInitClueTenStep() {
  yield put(initClueTenStep());
  yield put(fetchListCountry());

  yield takeLatest([ACTION_CREATE_CLUE_TEN_STEP], function* (action) {
    yield put(createClueTenStepAPI(action.payload));
  });

  yield takeLatest([REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS], function* (_action) {
    yield put(showToastAlert('Create ten step hunt successfully'));
    yield put(fetchUserInfo());
    yield put(goToPage(ROUTE_CLUES));
  });

  yield takeLatest([REQUEST_CREATE_CLUE_TEN_STEP_FAILURE], function* (action) {
    const errorMessage = action?.payload?.data?.message;
    yield put(showToastAlert(errorMessage, 'error'));
  });
}

function* handleInitClueTenStepSkip() {
  yield put(initClueTenStep());
  yield put(fetchListCountry());

  yield takeLatest([ACTION_CREATE_CLUE_TEN_STEP_SKIP], function* (action) {
    yield put(createClueTenStepSkipAPI(action.payload));
  });

  yield takeLatest([REQUEST_CREATE_CLUE_TEN_STEP_SUCCESS_SKIP], function* (_action) {
    yield put(fetchUserInfo('', false));
  });

  yield takeLatest([REQUEST_CREATE_CLUE_TEN_STEP_FAILURE_SKIP], function* (action) {
    const errorMessage = action?.payload?.data?.message;
    yield put(showToastAlert(errorMessage, 'error'));
  });
}

export function* loadClueTenStepPage() {
  yield all([fork(handleInitClueTenStep), fork(handleInitClueTenStepSkip)]);
}
